import React from 'react';
import myLabsLogo from '../../assets/mylabs-small-logo.png';

interface LoadingSpinnerProps {
    className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({className = ''}) => {
    return (
        <div className={`fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-95 ${className}`}>
            <div className="flex flex-col items-center space-y-4">
                {/* MyLabs Logo */}
                <div className="mb-4">
                    <img src={myLabsLogo} alt="MyLabs" className="h-12" />
                </div>

                {/* Spinning Loader */}
                <div className="relative">
                    <div className="w-12 h-12 border-4 border-gray-200 rounded-full animate-spin border-t-mld-primary"></div>
                </div>

                {/* Loading Text */}
                <p className="text-mld-text-primary text-lg font-medium">Loading your health data...</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;
